import { createElement } from 'react'

import { Table } from 'shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Surname',
    accessor: 'surname',
  },
  {
    Header: 'Nationality',
    accessor: 'nationality',
  },
  {
    Header: 'Birthdate',
    accessor: 'dateOfBirth',
  },
  {
    Header: 'Personal Website',
    accessor: 'personalWebsite',
    Cell: Table.CellRenderers.LinkCell,
  },
]
